<script>
import { Pie, mixins } from 'vue-chartjs';
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import $ from 'jquery';

export default {
    name: 'PensumChart',
    extends: Pie,
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Object,
            required: true,
        },
        options: {
            type: Object,
            required: true,
        },
        tooltips: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.options.tooltips.enabled = this.tooltips;
        Chart.plugins.unregister(ChartDataLabels);
        this.options.tooltips.custom = this.customTooltip;

        this.renderChart(this.chartData, this.options);
    },
    methods: {
        customTooltip(tooltip) {
            let $tooltipEl = $('#chartjs-tooltip');
            // eslint-disable-next-line
            const pos = $(this.$data._chart.canvas).offset();


            if ($tooltipEl.length === 0) {
                $tooltipEl = $(`
                    <div id="chartjs-tooltip" class="chartjs-tooltip">
                        <span class="chartjs-tooltip__square"></span>
                        <span class="chartjs-tooltip__label"></span>
                    </div>`);
                $('body').append($tooltipEl);
            }

            if (tooltip.body) {
                const color = tooltip.labelColors[0].backgroundColor;
                $tooltipEl.css({
                    left: pos.left,
                    top: pos.top,
                });
                $tooltipEl.find('.chartjs-tooltip__label').text(tooltip.body[0].lines[0]);
                $tooltipEl.find('.chartjs-tooltip__square').css('background-color', color);
            }

            if (tooltip.opacity === 0) {
                $tooltipEl.css({
                    opacity: 0,
                    transition: 'opacity 0.3s',
                    display: 'none',
                });
            } else {
                $tooltipEl.css({
                    opacity: 1,
                    transition: 'opacity 0.3s',
                    display: 'block',
                });
            }
        },
    },
};
</script>
<style lang="scss">
.chartjs-tooltip{
    position: absolute;
    z-index: 999;
    min-width: 100px;
    background-color: rgba(black, 0.5);
    white-space: nowrap;
    color: white;
    text-transform: uppercase;
    font-size: 0.725rem;
    padding: 0.2rem 1rem 0.2rem 0.5rem;
    transform: translateY(-100%) translateX(-20%);
    border-radius: 2px;
    line-height: 1;
    display: none;
}
.chartjs-tooltip__square{
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 2px;
    margin-right: 0.2rem;
}
</style>
